import React, { useMemo } from 'react';
import { parse, format } from 'date-fns';
import { Button, Flex, Pane, Text } from '@leverege/ui-elements';
import { DailyHours } from '@leverege/operating-hours';
import I18N from '@leverege/i18n';
import S from './DailyHoursListEditor.css';
const {
  t,
  tIcon
} = I18N.ns('imagine.operatingHours.DailyHoursListEditor');
export default function DailyHoursListEditor(props) {
  const {
    value,
    eventData,
    onDelete,
    blueprint
  } = props;
  const date = useMemo(() => {
    return format(parse(eventData, 'yyyy-MM-dd', new Date()), 'MM-dd-yyyy');
  }, [eventData]);
  const ranges = DailyHours.getRanges(value);
  const open = DailyHours.getOpen(value);
  return /*#__PURE__*/React.createElement(Pane, {
    className: S.item,
    variant: "overrideItem"
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "captionSmallBold"
  }, "Override Name"), /*#__PURE__*/React.createElement(Text, {
    variant: "captionSmall"
  }, value.name)), /*#__PURE__*/React.createElement(Flex, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "captionSmallBold"
  }, "Override Date"), /*#__PURE__*/React.createElement(Text, {
    variant: "captionSmall"
  }, date)), /*#__PURE__*/React.createElement(Flex, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "captionSmallBold"
  }, "Hours"), open && ranges && ranges.length > 0 ? /*#__PURE__*/React.createElement(Flex, {
    variant: "colS"
  }, ranges.map((range, index) => {
    const val = `${range.start} - ${range.end}`;
    return /*#__PURE__*/React.createElement(Text, {
      variant: "captionSmall",
      key: `${val}-${index}`
    }, val);
  })) : /*#__PURE__*/React.createElement(Text, {
    variant: "captionSmall"
  }, t('closed', {
    name: blueprint?.name || 'Location'
  }))), /*#__PURE__*/React.createElement(Button, {
    variant: "linkNeutral",
    icon: tIcon('deleteIcon', 'fa fa-fw fa-trash'),
    onClick: onDelete,
    eventData: eventData
  }));
}